

export function stringToBlob(data: string, dataType: 'csv'): Blob {
    const mimeType = dataType === 'csv' ? 'text/csv' : 'text/plain';
    return new Blob([data], { type: mimeType });
}
